<template>
  <ShortcutWrapper :nShortcutRequiredClaim="UserClaims.ContractManager" @n-shortcut="mutate(null, 'create')">
    <v-container fluid>
      <v-row dense>
        <v-col cols="12">

          <Dialog
          :stateId="dialogId"
          maxWidth="400px"
          @click:outside="close"
          @dialog-closing="close"
          @close="close">
            <ConfirmDelete
            v-if="confirmDeleteDialog"
            @delete="performDelete"
            @cancel-delete="close"
            :title="$t('visitType')"/>
            <TractVisitTypeForm
            v-else
            :propTractVisitType="tractVisitType"
            @tract-visit-type-mutated="refresh" />
          </Dialog>

          <v-row>
            <v-col style="max-width: 800px;">
              <DataTable
              :tableHeightCalculationData="{ offset: 590, absoluteMinimum: 128 }"
              :customCells="customColumns"
              :headers="headers"
              :items="allTractVisitTypes"
              :loading="loading">

                <template #actions="{ item }">
                  <Icon
                  icon="mdi-pencil"
                  :tooltipText="$t('edit')"
                  @icon-clicked="mutate(item, 'edit')"
                  :disabled="!userAssignedClaim(UserClaims.ContractManager)"
                  elementId="tract-visit-type-edit"/>
                  <Icon icon="mdi-delete-forever"
                  :tooltipText="$t('delete')"
                  @icon-clicked="mutate(item, 'delete')"
                  :disabled="!userAssignedClaim(UserClaims.ContractManager)"
                  elementId="tract-visit-type-delete"/>
                </template>

                <template #custom-controls>
                  <Icon
                  icon="mdi-refresh"
                  :tooltipText="$t('refresh')"
                  @icon-clicked="refresh"
                  :small="false"/>
                  <Icon icon="mdi-plus"
                  :tooltipText="$t('newVisitType')"
                  @icon-clicked="mutate(null, 'create')"
                  :small="false"
                  :disabled="!userAssignedClaim(UserClaims.ContractManager)"
                  elementId="tract-visit-type-create"/>
                </template>

              </DataTable>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </ShortcutWrapper>
</template>

<script>
import { cloneDeep } from 'lodash'
import { mapActions, mapGetters } from 'vuex'
import { UserClaims } from '@/utils/Enumerations.js'
import TractVisitHeaders from '@/headers/TractVisit'
import { userAssignedClaim } from '@/utils/ClaimUtility'
import { uniqueDialogId } from '@/utils/componentHelpers'

export default {
  name: 'TractVisitTypeSettings',

  components: {
    ConfirmDelete: () => import('@/components/helper/ConfirmDelete.vue'),
    ShortcutWrapper: () => import('@/components/core/ShortcutWrapper.vue'),
    Icon: () => import('@/components/helper/Icon.vue'),
    DataTable: () => import('@/components/core/table/DataTable.vue'),
    Dialog: () => import('@/components/Dialog.vue'),
    TractVisitTypeForm: () => import('@/components/settings-components/tract-settings/tract-visit-type/TractVisitTypeForm.vue')
  },

  created () {
    this.refresh()
  },

  computed: {
    ...mapGetters('tract-visit-type', ['allTractVisitTypes']),

    headers () {
      return TractVisitHeaders.tractVisitTypeHeaders()
    },

    customColumns () {
      return [{
        slotName: 'actions',
        value: 'actions'
      }]
    }
  },

  data: () => ({
    confirmDeleteDialog: false,
    loading: false,
    tractVisitType: undefined,
    dialogId: uniqueDialogId('tract-visit-type-settings-dialog'),
    UserClaims
  }),

  methods: {
    ...mapActions('tract-visit-type', ['fetchTractVisitTypes', 'deleteTractVisitType']),
    ...mapActions('dialog', ['openOrUpdateDialog', 'closeDialogsAtOrAbove']),

    userAssignedClaim,

    refresh () {
      this.close()
      this.loading = true
      this.fetchTractVisitTypes().finally(() => {
        this.loading = false
      })
    },

    mutate (tractVisitType, mutationType) {
      this.tractVisitType = cloneDeep(tractVisitType)
      if (mutationType === 'delete') this.confirmDeleteDialog = true
      this.openOrUpdateDialog(this.dialogId)
    },

    close () {
      this.confirmDeleteDialog = false
      this.closeDialogsAtOrAbove(this.dialogId)
      this.tractVisitType = undefined
    },

    async performDelete () {
      await this.deleteTractVisitType(this.tractVisitType.tractVisitTypeId)
      this.refresh()
    }
  }
}
</script>
